import { Pipe, PipeTransform } from '@angular/core';
import { MenuItemView } from '@app/models/menu/menu-item-view';
import { MenuSectionView } from '@app/models/menu/menu-section-view';

@Pipe({
  name: 'filterMenuItems',
  standalone: true
})
export class FilterMenuItemsPipe implements PipeTransform {
  transform(sections: MenuSectionView[], searchTerm: string): MenuSectionView[] {
    if (!sections || !searchTerm || !searchTerm.trim()) {
      return sections;
    }

    const lowerSearchTerm = searchTerm.toLowerCase();
    const menuItemHasSearchTerm = (item: MenuItemView) => item.name.toLowerCase().includes(lowerSearchTerm)
        || item.description?.toLowerCase().includes(lowerSearchTerm);

    return sections
        .filter((x: MenuSectionView) => x.menuItems.some(menuItemHasSearchTerm))
        .map((x: MenuSectionView) => ({
          ...x,
          menuItems: x.menuItems.filter(menuItemHasSearchTerm)
        }));
  }
}
